import {ApplicationConfig, importProvidersFrom, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {
    HttpClient,
    HttpHandler,
    provideHttpClient,
    withInterceptors,
    withInterceptorsFromDi,
} from '@angular/common/http';
import {routes} from './app.routes';
import {DecimalPipe, DATE_PIPE_DEFAULT_OPTIONS} from '@angular/common';
import {MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS} from '@angular/material/button-toggle';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MatIconRegistry} from '@angular/material/icon';
import {AuthenticatedUserGuard} from 'src/app/shared/guards/authenticated-user.guard';
import {HttpInterceptorService} from 'src/app/shared/services/http-interceptor.service';
import {Angulartics2Module} from 'angulartics2';
import {provideNativeDateAdapter} from '@angular/material/core';
import {ongApiKeyInterceptor} from 'src/app/shared/interceptors/ong-api-key.interceptor';
import {VULCAN_DATE_TIME_PICKER_DEFAULT_OPTIONS} from '@eagle-i/vulcan-component-library';
import {configureVulcanMapAdapterDefaults} from 'src/app/routes/map/vulcan-map-adapter/config/vulcan-map-adapter.config';
import {getEagleIVulcanMapAdapterDefaultOptions} from 'src/app/routes/map/map-view-presets';

export function EagleIHttpServiceFactory(handler: HttpHandler) {
    return new HttpInterceptorService(handler);
}

export const appConfig: ApplicationConfig = {
    providers: [
        AuthenticatedUserGuard,
        MatIconRegistry,
        DecimalPipe,
        {
            provide: HttpClient,
            useFactory: EagleIHttpServiceFactory,
            deps: [HttpHandler],
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {appearance: 'outline', theme: 'primary', subscriptSizing: 'dynamic'},
        },
        {
            provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
            useValue: {hideSingleSelectionIndicator: true, hideMultipleSelectionIndicator: true},
        },
        {
            provide: VULCAN_DATE_TIME_PICKER_DEFAULT_OPTIONS,
            useValue: {matDensity: -3},
        },
        provideHttpClient(withInterceptors([ongApiKeyInterceptor]), withInterceptorsFromDi()),
        {provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: {dateFormat: 'MM/dd/yyyy hh:mm a'}},
        provideZoneChangeDetection({eventCoalescing: true}),
        provideAppInitializer(() => configureVulcanMapAdapterDefaults(getEagleIVulcanMapAdapterDefaultOptions)),
        provideRouter(routes),
        importProvidersFrom(Angulartics2Module.forRoot()),
        provideNativeDateAdapter(),
    ],
};
